import { useMemo } from 'react';
import { useAuth } from 'src/hooks/use-auth';
import { paths } from 'src/paths';
import { roles } from 'src/roles';
import { tr } from 'src/locales/tr';

export const useCabinetNavItems = () => {
    const { user } = useAuth();
    const role = user?.role;

    return useMemo(() => {
        const items = [];

        if (role === roles.WORKER) {
            items.push({ title: tr("Find projects"), path: paths.cabinet.projects.find.index });
            items.push({ title: tr("My works"), path: paths.cabinet.projects.contractor });
        }

        items.push({ title: tr("My projects"), path: paths.cabinet.projects.index, exactSearch: role === roles.WORKER });
        items.push({ title: tr("Post a project"), path: paths.cabinet.projects.create });
        items.push({ title: tr("Dashboard"), path: paths.dashboard.overview });
        items.push({ title: tr("Support"), path: paths.contact });

        return items;
    }, [role]);
};
